import React from 'react';

import { SVGComponentProps } from './svg.types';

const SaveAltSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1938_64032)">
          <path
            d="M6.53287 2.03794L6.53287 6.5728L5.70659 5.75337C5.58247 5.62955 5.43518 5.53139 5.27313 5.4645C5.11107 5.3976 4.93743 5.36328 4.76211 5.36349C4.5868 5.36371 4.41324 5.39845 4.25135 5.46573C4.08946 5.53302 3.9424 5.63154 3.81859 5.75565C3.69477 5.87977 3.59661 6.02706 3.52972 6.18912C3.46282 6.35117 3.4285 6.52481 3.42871 6.70013C3.42892 6.87544 3.46367 7.049 3.53095 7.21089C3.59824 7.37278 3.69675 7.51984 3.82087 7.64365L6.93859 10.7545C7.06355 10.8793 7.21206 10.978 7.37549 11.0449C7.53891 11.1119 7.714 11.1457 7.8906 11.1444C8.06719 11.1431 8.24177 11.1068 8.40422 11.0375C8.56666 10.9682 8.71372 10.8674 8.83687 10.7408L11.9306 7.55223C12.0531 7.42676 12.1496 7.2784 12.2147 7.11561C12.2799 6.95283 12.3123 6.77881 12.3102 6.60349C12.3081 6.42817 12.2714 6.25499 12.2024 6.09383C12.1333 5.93267 12.0332 5.78669 11.9077 5.66423C11.7823 5.54176 11.6339 5.4452 11.4711 5.38007C11.3083 5.31494 11.1343 5.28251 10.959 5.28464C10.7837 5.28676 10.6105 5.32339 10.4493 5.39244C10.2882 5.4615 10.1422 5.56161 10.0197 5.68708L9.20373 6.54308L9.20373 2.03794C9.19357 1.69053 9.04841 1.36075 8.79908 1.1186C8.54975 0.876458 8.21586 0.741012 7.8683 0.741012C7.52074 0.741012 7.18685 0.876458 6.93752 1.1186C6.68819 1.36075 6.54304 1.69053 6.53287 2.03794Z"
            fill={fill}
          />
          <path
            d="M15.5691 15.3805C15.7059 15.2441 15.8144 15.082 15.8884 14.9036C15.9623 14.7251 16.0002 14.5337 15.9999 14.3405L15.9999 10.6548C16.0054 10.4583 15.9714 10.2626 15.9 10.0795C15.8286 9.89629 15.7211 9.7293 15.5841 9.58835C15.447 9.44741 15.2831 9.33537 15.102 9.25887C14.9208 9.18237 14.7262 9.14295 14.5296 9.14295C14.333 9.14295 14.1384 9.18237 13.9573 9.25887C13.7762 9.33537 13.6123 9.44741 13.4752 9.58835C13.3381 9.7293 13.2307 9.89629 13.1593 10.0795C13.0878 10.2626 13.0539 10.4583 13.0593 10.6548L13.0593 12.8708L2.94163 12.8708L2.94163 10.6548C2.94163 10.2647 2.78667 9.89059 2.51083 9.61475C2.23499 9.33891 1.86087 9.18395 1.47077 9.18395C1.08068 9.18395 0.70656 9.33891 0.430721 9.61475C0.154882 9.89059 -8.19179e-05 10.2647 -8.18838e-05 10.6548L-8.15616e-05 14.3405C-8.15447e-05 14.5337 0.0379634 14.7249 0.111881 14.9034C0.185798 15.0818 0.29414 15.244 0.430722 15.3806C0.567303 15.5172 0.72945 15.6255 0.907902 15.6994C1.08635 15.7733 1.27762 15.8114 1.47078 15.8114L14.5291 15.8114C14.7223 15.8117 14.9136 15.7738 15.0921 15.6998C15.2706 15.6259 15.4327 15.5174 15.5691 15.3805Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_1938_64032">
            <rect width="16" height="16" fill="white" transform="matrix(0 -1 -1 0 16 16)" />
          </clipPath>
        </defs>
      </svg>

      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        height="20"
        viewBox="0 0 24 24"
        width="20"
        {...otherProps}
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />
      </svg> */}
    </span>
  );
};

export default SaveAltSVG;
